import { Switch as AntdMobileSwtich } from "antd-mobile";

const Switch = (props) => {
  return (
    <AntdMobileSwtich {...props}></AntdMobileSwtich>
  );
};

export default Switch;
